import { render, staticRenderFns } from "./customerInfo.vue?vue&type=template&id=7997a6fc&scoped=true"
import script from "./customerInfo.vue?vue&type=script&lang=js"
export * from "./customerInfo.vue?vue&type=script&lang=js"
import style0 from "./customerInfo.vue?vue&type=style&index=0&id=7997a6fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7997a6fc",
  null
  
)

export default component.exports